import { render, staticRenderFns } from "./backToIngredients.vue?vue&type=template&id=26aba1c0&scoped=true&"
import script from "./backToIngredients.vue?vue&type=script&lang=js&"
export * from "./backToIngredients.vue?vue&type=script&lang=js&"
import style0 from "./backToIngredients.vue?vue&type=style&index=0&id=26aba1c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26aba1c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/dvl/web2/compiere-all/pharmanord2011/template/webapps/relationlistwidget/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26aba1c0')) {
      api.createRecord('26aba1c0', component.options)
    } else {
      api.reload('26aba1c0', component.options)
    }
    module.hot.accept("./backToIngredients.vue?vue&type=template&id=26aba1c0&scoped=true&", function () {
      api.rerender('26aba1c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/backToIngredients.vue"
export default component.exports